import React from 'react';
import { Box, Card, CardContent, Typography, Chip, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useGetSettingsQuery } from 'state/api';

// Read-only status card. Deployment/updates are handled by the hosting
// environment, so there is nothing to configure or upload here.
const SoftwareUpdate = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const version =
    settings.version ||
    settings.custom?.appVersion ||
    process.env.REACT_APP_VERSION ||
    null;

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
            <CheckCircleOutlineIcon color="success" />
            <Typography variant="h5" fontWeight="bold">
              System up to date
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary" mb={2}>
            You are running the latest version. Updates are managed and deployed
            through your hosting environment — no manual action is required here.
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              Current version
            </Typography>
            <Chip
              label={version ? `v${version}` : 'Latest'}
              color="primary"
              size="small"
            />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SoftwareUpdate;
